var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloads(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.485 7.178c.176-.176.176-.457 0-.597l-.703-.704c-.14-.175-.422-.175-.598 0L7.88 9.287V.535a.427.427 0 00-.422-.422h-.985c-.21 0-.421.21-.421.422v8.754l-3.27-3.41c-.176-.176-.457-.176-.598 0l-.703.703c-.175.14-.175.421 0 .597l5.203 5.203a.405.405 0 00.598 0l5.203-5.203zm.844 6.856H.673a.427.427 0 00-.422.422v.984c0 .246.176.422.422.422h12.656a.427.427 0 00.422-.422v-.984a.454.454 0 00-.422-.422z"
  })));
}
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAic3RhdGljL2Nzcy84YzVkOGU2YWExMTBjNzBjNWJmYTFmODI0ZDVlZmFlYy5zdmciOw==";
export { SvgDownloads as ReactComponent };